// extracted by mini-css-extract-plugin
export default {"PasswordResetPhone":"zn_a bik_qt bik_a bik_w bik_ea bik_tl"};